import { createSelector } from '@reduxjs/toolkit';
import { ERoomsTotal } from '../../../../packages/api-models/common/json_query';
import { selectRoomsCount } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: '1', value: ERoomsTotal.One },
  { label: '2', value: ERoomsTotal.Two },
  { label: '3', value: ERoomsTotal.Three },
  { label: '4', value: ERoomsTotal.Four },
  { label: '5', value: ERoomsTotal.Five },
];

export const selectFlatRoomsFilter = createSelector(selectRoomsCount, value => ({
  label: 'Комнат в квартире',
  value: value?.length ? (value as ERoomsTotal[]) : [null],
  options: OPTIONS,
}));
